import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {
    TransformCaller
} from '../../../source/src/transformCaller';
import { TransformResponse as TransformCallerDestResponse } from '../../../calleddest/src/transform';
import { format } from 'one-util-date';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton
} from 'one-model-local';
import {
    setSelectedNextgenAction,setPatientSelectedAction,
} from 'one-state-subject/src/actions';
import {
    selectAction as sourceSelectAction,
    addAction as sourceAddAction,
} from 'one-state-source-local';

import axios from 'axios';
import {
    setNotificationAction
} from 'one-state-errorhandle';
import {
    setAction,
} from 'one-state-calldest/src/action';
import { Disposition } from 'one-model-local';

import {
setAction as lookupErrorSet,
} from "one-state-subjecterror/src/action";

import { proxyRequestThruGadgetsIO } from 'one-gadget-loader';


export const enum Types {
    GetSubjects = 'caller-patient-nextgen',
    PushtoSubject = 'one-state-subject/set',
    GetDrawer = 'one-patient-drawer/set',
    HEALTHALERT = 'healthAlert',
    ConsolidateAPIOne = 'consolidated-api-one',
    SETCALLERDBDETAILS = 'one-state-source/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}


const pushToSubject = (payload: any) => ({ type: Types.PushtoSubject, payload });
// const pushToSelect = (payload: any) => setSelectedAction(payload);
const pushToDrawer = (payload: any) => ({ type: Types.GetDrawer, payload });
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);

const pushtoSETCallerDBPatient = (payload: any) => ({ type: Types.SETCALLERDBDETAILS, payload });
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });


function isJson(str: any) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

/**
 * This Fuction will fetch the data form EPIC Patient Lookup API
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchPatientsNextgen = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId,teamName, alertnotification, settings: { servers, compatible, nextgenendpoints: {  getpatientnextgen} } } = context;
        const { contact_center_type, finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.GetSubjects),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                const dataresponse: any = action.payload;
                let data:any = {}
                let callType = sessionStorage.getItem("callType")
                let payloadparam=""
                let getParams = "";
                log.debug("one-nextgen", "fetchPatientsNextgen request", action);
                const getRequest = (reqresponse: any) => {
                    let respreturn;
                    if (reqresponse) {
                        let headers = new Headers();
                        headers.append("Accept", "application/json");
                        //  todo: delegate to one-server-ha oneview
                        headers.append("Content-Type", "text/plain");
                        if(contact_center_type === "finesse") {
                            if (reqresponse.number && reqresponse.subjectid) {
                                getParams += "&quickSearchId=PhoneNumber" ;
                                getParams += "&quickSearchInput=" + reqresponse.number;
                                payloadparam=reqresponse.number
                            }
                            else if (reqresponse.subjectid) {
                                getParams += "&quickSearchId=MedicalRecordNumber" ;
                                getParams += "&quickSearchInput=" + reqresponse.subjectid;
                            }
                            else if (reqresponse.sourceid) {
                                getParams += "&quickSearchId=MedicalRecordNumber" ;
                                getParams += "&quickSearchInput=" + reqresponse.sourceid;
                            }
                          
                            else {
                                    getParams += "&quickSearchId=PhoneNumber" ;
                                    getParams += "&quickSearchInput=" + reqresponse.number;
                                
                            } 
                            // Remove the leading "&" if there are any parameters
                            if (getParams.length > 0) {
                                getParams = "?" + getParams.substring(1);
                            }
                        }
                        else if(contact_center_type === "vonage" || contact_center_type === "wxcc" || contact_center_type === "five9" || contact_center_type==="twilio" || contact_center_type === 'genesys' || contact_center_type === "inContact" || contact_center_type === "ringcentral" || contact_center_type === "intermedia") {


                             if (reqresponse.subjectid) {
                                getParams += "&quickSearchId=MedicalRecordNumber" ;
                                getParams += "&quickSearchInput=" + reqresponse.subjectid;
                            }
                            else if (reqresponse.sourceid) {
                                getParams += "&quickSearchId=MedicalRecordNumber" ;
                                getParams += "&quickSearchInput=" + reqresponse.sourceid;
                            }
                            else {
                                    getParams += "&quickSearchId=PhoneNumber" ;
                                    getParams += "&quickSearchInput=" + reqresponse.number;
                                
                            }
        
                           
                          
                            // Remove the leading "&" if there are any parameters
                            if (getParams.length > 0) {
                                getParams = "?" + getParams.substring(1);
                            }
                        }
                        if(contact_center_type==="inContact" &&(reqresponse?.token ||  reqresponse?.tokenstr)){
                            getParams +="&token="+reqresponse?.token
                            getParams +="&tokenstr="+reqresponse?.tokenstr
                            }
                        let response;
                        response = server.get({
                            path: getpatientnextgen +getParams,
                            headers: headers
                        })
                                .then((resp: any) => resp)
                                .catch((responseerror: any) => {
                                    log.error("one-epic", "fetchPatientsNextgen Error", responseerror);
                                    // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                                    if (responseerror?.status === 0) {
                                        if (alertnotification?.isEnabled()) {
                                            var timestamp = new Date().toJSON();
                                            alertnotification.notify({
                                                "error_code": "930-31",
                                                "error_type": "SERVER_ERROR",
                                                "error_description": "Unable to reach active servers",
                                                "error_supertype": "SERVER_FAILS",
                                                "error_detail": "Unable to reach any of server for retring data ",
                                                "alert": "Yes",
                                                "timestamp": timestamp,
                                                "params": responseerror
                                            });
                                        }
                                    }
                                    let error = [
                                    {
                                        "error_code": 32001,
                                        "error_type": "Bad Gateway Error",
                                        "display_text": "Oops! An error occured. Please contact your administrator",
                                        "http_code": "504",
                                        "error_description": "",
                                        "error_detail": "",
                                        "audit_log": {
                                            "channel": "Patient Lookup",
                                            "timestamp": "2023-09-07T06:25:39.982Z",
                                            "message_id": 34058
                                        }
                                    }
                                    ]
                                    let subjecterror: ErrorObject = {}
                                    if(responseerror.status === undefined) {
                                        subjecterror = {
                                            source: "Subject",
                                            type: "error",
                                            status: 502,
                                            erroritems: error,
                                            error_date: errorDate,
                                            error_time: errorTime
                                        };
                                        if (alertnotification?.isEnabled()) {
                                            var timestamp = new Date().toJSON();
                                            alertnotification.notify({
                                                "error_code": "930-31",
                                                "error_type": "SERVER_ERROR",
                                                "error_description": "Unable to reach active servers",
                                                "error_supertype": "SERVER_FAILS",
                                                "error_detail": "Unable to reach any of server for retring data ",
                                                "alert": "Yes",
                                                "timestamp": timestamp,
                                                "params": responseerror
                                            });
                                        }
                                    }
                                    else if(responseerror?.status) {
                                        subjecterror = {
                                            source: "Subject",
                                            type: "error",
                                            status: responseerror?.status,
                                            erroritems: responseerror?.errors,
                                            error_date: errorDate,
                                            error_time: errorTime
                                        };
                                    }

                                    return subjecterror;
                                })
                        
                        
                        respreturn = from(response);
                    } else {
                        respreturn = from([]);
                    }
                    log.debug("one-epic", "fetchPatientsNextgen response", respreturn);
                    return respreturn;
                }
                return getRequest(dataresponse).
                    pipe(
                        map(response => TransformResponse(response, context))).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushToSubject(response.subjectdata)
                            ];
                            //For Subject
                            const selected = response.subjectdata.find(
                                (item: any) => item.id === dataresponse.subjectid
                            );
                            if (selected && 'id' in selected) {
                                actions.push(setSelectedNextgenAction(selected));
                            }
                            //For Source
                            const sourceselected = response.subjectdata.find(
                                (item: any) => item.id === dataresponse.sourceid
                            );
                            if (sourceselected && 'id' in sourceselected) {
                                actions.push(sourceAddAction(sourceselected));
                                actions.push(sourceSelectAction(sourceselected.id));
                                //Making skeleton to false
                                let skeletonsource: Skeleton = {
                                    source_skeleton: false
                                }
                            actions.push(pushToSkeleton(skeletonsource));
                            }
                            //Making skeleton to false
                            let skeletonsource: Skeleton = {
                                subject_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonsource));
                            // check for error messages.
                            if (response.error) {
                                actions.push(addAction(response.error));
                                //To store the error object in the reducer.
                                actions.push(lookupErrorSet(response.error));
                                let disp: Disposition = { value: "997" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                }  else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                  else if(contact_center_type==="intermedia"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                                  }  
                                else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = payloadparam;
                                disp.meta03 = response.error.status;
                                disp.meta04 = response.error?.erroritems?.[0]?.error_detail;
                                disp.meta05 = "Failed to fetch the Patient details"
                                actions.push(pushToDisposition(disp));
                            } else {
                                //success scenario
                                let disp: Disposition = { value: "180" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                }
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="intermedia"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                                  }   
                                  else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                }

                                disp.meta02=  payloadparam
                                disp.meta03 = "Patient details fetched successfully"
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


/**
 * This Fuction will fetch the data form Consolidated API#1
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */


/**
 * 
 * This Function will make an proxy request to Mirth Endpoints through Finesse Proxy.
 * 
 * 
 * @param path is mirth endpoint
 * @param data  is the request data
 * @param apitoken  is api token
 * @param locations is the base url array
 * @param log is the log variable
 * @param method_type type of API eg: GET, POST etc.,
 * @param alertnotification is alertnotification.
 */

export const InvokeFinesseProxy = (path: any, data: any, apitoken: any, locations: any, log: any, method_type: string, alertnotification: any) => {

    let url: any;
    let url_one: any;
    if(locations.length > 1){
         url = locations[0]?.base + path;
         url_one = locations[1]?.base + path;
    }else{
        url = locations[0]?.base + path;
        url_one = locations[0]?.base + path;
    }
    
    const errorTime = format(new Date(), 'LT');
    const errorDate = format(new Date(), 'LL');

    return new Promise((resolve, reject) => proxyRequestThruGadgetsIO(url, {
        method: method_type,
        contentType: 'application/json',
        authorization: 'Basic ' + apitoken?.token,
        content: JSON.stringify(data)
    }, {
        success: function (response: any) {
            console.debug("InvokeFinesseProxy - proxyRequestThruGadgetsIO() success callback");
            console.log('InvokeFinesseProxy Response', response);
            let text: any = JSON.parse(isJson(response?.text) ? response.text : null);
            let values: Array<any> = [];
            if (text && text?.results && text?.results?.length > 0) {
                values = text?.results;
            }
            return resolve(values);

        },
        error: function (error: any) {
            console.debug("InvokeFinesseProxy - proxyRequestThruGadgetsIO() error callback");
            console.log('InvokeFinesseProxy Error', error);
            return reject(error);
        }
    })).then((responsefound: any) => responsefound)
        .catch((responseresult: any) => {
            log.error(
                "ccw-gadget,InvokeFinesseProxy-epic",
                "fetch-InvokeFinesseProxy", {
                responseresult
            }
            );
            // SEND to ALERT snotificiton/NOCserver for errors
            if (responseresult.status === 0) {
                if (alertnotification?.isEnabled()) {
                    var timestamp = new Date().toJSON();
                    alertnotification.notify({
                        "error_code": "930-31",
                        "error_type": "SERVER_ERROR",
                        "error_description": "Unable to reach active servers",
                        "error_supertype": "SERVER_FAILS",
                        "error_detail": "Unable to reach any of server for retring data ",
                        "alert": "Yes",
                        "timestamp": timestamp,
                        "params": responseresult
                    });
                }
            }

            return new Promise((resolve, reject) => proxyRequestThruGadgetsIO(url_one, {
                method: method_type,
                contentType: 'application/json',
                authorization: 'Basic ' + apitoken?.token,
                content: JSON.stringify(data)
            }, {
                success: function (response: any) {
                    console.debug("InvokeFinesseProxy - proxyRequestThruGadgetsIO() success callback");
                    console.log('InvokeFinesseProxy Response', response);
                    let text: any = JSON.parse(isJson(response?.text) ? response.text : null);
                    let values: Array<any> = [];
                    if (text && text?.results && text?.results?.length > 0) {
                        values = text?.results;
                    }
                    return resolve(values);

                },
                error: function (error: any) {
                    console.debug("InvokeFinesseProxy - proxyRequestThruGadgetsIO() error callback");
                    console.log('InvokeFinesseProxy Error', error);
                    return reject(error);
                }
            })).then((responsefound: any) => responsefound)
                .catch((responseresult: any) => {
                    log.error(
                        "ccw-gadget,InvokeFinesseProxy-epic",
                        "fetch-InvokeFinesseProxy", {
                        responseresult
                    }
                    );
                    // SEND to ALERT snotificiton/NOCserver for errors
                    if (responseresult.status === 0) {
                        if (alertnotification?.isEnabled()) {
                            var timestamp = new Date().toJSON();
                            alertnotification.notify({
                                "error_code": "930-31",
                                "error_type": "SERVER_ERROR",
                                "error_description": "Unable to reach active servers",
                                "error_supertype": "SERVER_FAILS",
                                "error_detail": "Unable to reach any of server for retring data ",
                                "alert": "Yes",
                                "timestamp": timestamp,
                                "params": responseresult
                            });
                        }
                    }
                    let text: any = JSON.parse(isJson(responseresult?.text) ? responseresult?.text : null);
                    let values: Array<any> = [];
                    if (text && text?.error && text?.error?.length > 0) {
                        values = text?.error;
                    }
                    console.log("text::", text);
                    let sourceerror: ErrorObject = {
                        source: "InvokeFinesseProxy",
                        type: "error",
                        status: responseresult?.rc,
                        erroritems: values,
                        error_date: errorDate,
                        error_time: errorTime
                    };
                    return sourceerror;
                })
        })


}